import axios from 'axios';
import { getToken } from '../Session/Session'

export default new axios.create(
    {
        baseURL: window.env.API_URL,
        headers: { 'Authorization': 'Bearer ' + getToken() }
    }
)